import { send } from '../../lib/send';
import { IAPI } from '../../lib/models/api';
import { LoanQuoteRequest } from '@axo/shared/data-access/types/loan_quote';

export function patchLoanQuote({ url: { service: baseURL }, token }: IAPI) {
  return async ({
    loanQuoteID,
    data,
  }: LoanQuoteRequest): Promise<LoanQuoteRequest> =>
    send({
      baseURL,
      token,
      path: `/loan-quote/${loanQuoteID}`,
      method: 'PATCH',
      body: data,
    });
}
